{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "UWI",
      "folder": "Well Header",
      "width": 170,
      "isShownByDefault": true,
      "tnum": true,
    },
    "gpt": {
      "hint": "UWI / Well Identifier stored in DB as a compact string with no separators (strip spaces, '/', '-', etc.). RULE: If user provides any UWI-like token (often starts with '100', contains 'W' like 'W6', or uses '/' and '-' separators), filter using internal_id ONLY. Normalize user input: remove all non-alphanumeric chars, uppercase. Example: '100/14-08-078-11W6/00' => '100140807811W600'. SQL: internal_id = <normalized> (or IN (...) for multiple). Do not use surface_location for UWIs.",
    },
  },
  "formatted_well_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formatted UWI",
      "folder": "Well Header",
      "width": 200,
      "tnum": true,
    },
    "gpt": {
      "exclude": true,
    },
  },
  "well_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Well Name",
      "folder": "Well Header",
      "width": 200,
    },
  },
  "license_number": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licence Number",
      "folder": "Well Header",
      "width": 125,
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Leading zeros possible — match with regexp '^(0*)' || input || '$'",
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["AB", "BC", "MB", "SK"],
    },
    "ui": {
      "label": "Province",
      "folder": "Well Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "licensee": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licensee",
      "folder": "Well Header",
      "width": 225,
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Use this column when a company name is mentioned unless specified otherwise",
    },
  },
  "licensee_brand": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licensee Brand",
      "folder": "Well Header",
      "width": 250,
    },
    "gpt": {
      "exclude": true,
    },
  },
  "licensee_history": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licensee History",
      "folder": "Well Header",
      "width": 250,
      "isNotSortable": true,
    },
    "gpt": {
      "hint": "A comma-separated list of all previous licensee names; avoid this column unless previous licensees are specifically requested",
    },
  },
  "operator": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Operator",
      "folder": "Well Header",
      "width": 250,
    },
    "gpt": {
      "hint": "Use this column only when an *operator* is explicitly mentioned",
    },
  },
  "field_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Field",
      "folder": "Well Header",
      "isShownByDefault": true,
    },
  },
  "pool_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Pool",
      "folder": "Well Header",
    },
  },
  "unit_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Unit",
      "folder": "Well Header",
    },
  },
  "unit_agreement_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Unit Agreement",
      "folder": "Well Header",
    },
  },
  "unit_status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Unit Status",
      "folder": "Well Header",
    },
  },
  "unit_operator": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Unit Operator",
      "folder": "Well Header",
    },
  },
  "producing_formation": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Producing Formation",
      "folder": "Well Header",
      "width": 200,
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Use this column for all generic formation queries unless specified otherwise",
    },
  },
  "projected_formation": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Projected Formation",
      "folder": "Well Header",
    },
  },
  "terminating_formation": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Terminating Formation",
      "folder": "Well Header",
      "width": 200,
    },
  },
  "intersecting_formations": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Intersecting Formations",
      "folder": "Well Header",
      "width": 200,
      "isNotSortable": true,
    },
  },
  "spud_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Spud Date",
      "folder": "Well Header",
      "isShownByDefault": true,
    },
  },
  "license_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Licence Date",
      "folder": "Well Header",
    },
  },
  "license_last_status_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Last Licence Status Date",
      "folder": "Well Header",
    },
  },
  "wellbore_last_status_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Last Well Status Date",
      "folder": "Well Header",
    },
  },
  "completion_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Latest Completion Date",
      "folder": "Well Header",
    },
    "gpt": {
      "hint": "Date of the most recent completion",
    },
  },
  "initial_completion_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Initial Completion Date",
      "folder": "Well Header",
    },
  },
  "on_production_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "On Production Date",
      "folder": "Well Header",
    },
    "gpt": {
      "hint": "Date the well was first put on production",
    },
  },
  "well_status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Provincial Status",
      "folder": "Well Header",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "well_fluid": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Provincial Fluid",
      "folder": "Well Header",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "well_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Provincial Type",
      "folder": "Well Header",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "well_structure": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["Commingled", "Drainage", "N/A"],
    },
    "ui": {
      "label": "Structure",
      "folder": "Well Header",
    },
  },
  "pn_well_status": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "Licenced",
        "Location",
        "Drilled",
        "Active",
        "Commingled",
        "Drain",
        "Suspended",
        "Abandoned Zone",
        "Abandoned",
        "Confidential",
        "Cancelled",
      ],
    },
    "ui": {
      "label": "Well Status",
      "folder": "Well Header",
      "width": 135,
      "isShownByDefault": true,
    },
  },
  "pn_well_fluid": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Well Fluid",
      "folder": "Well Header",
    },
  },
  "pn_well_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Well Type",
      "folder": "Well Header",
    },
  },
  "well_symbol_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Well Symbol",
      "folder": "Well Header",
    },
  },
  "license_status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licence Status",
      "folder": "Well Header",
    },
  },
  "kb_elevation": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "KB Elevation",
      "folder": "Well Header",
    },
  },
  "gl_elevation": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "Ground Elevation",
      "folder": "Well Header",
    },
  },
  "tmd": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "TMD",
      "folder": "Well Header",
      "width": 120,
      "isShownByDefault": true,
    },
  },
  "tvd": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "TVD",
      "folder": "Well Header",
      "width": 120,
      "isShownByDefault": true,
    },
  },
  "projected_depth_m": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "Projected Depth",
      "folder": "Well Header",
    },
  },
  "plug_back_depth_m": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "Plugback Depth",
      "folder": "Well Header",
    },
  },
  "trajectory": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "Vertical",
        "Horizontal",
        "Directional",
        "Slant",
        "Natural Drift",
      ],
    },
    "ui": {
      "label": "Trajectory",
      "folder": "Well Header",
    },
  },
  "rig_rlse_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Rig Release Date",
      "folder": "Well Header",
    },
  },
  "surface_abandonment_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Surface Abandonment Date",
      "folder": "Well Header",
    },
  },
  "zone_abandonment_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Zone Abandonment Date",
      "tooltip": "Date of the most recent \"Abandoned Zone\" status",
      "folder": "Well Header",
    },
  },
  "latest_plugback_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Plugback Date",
      "tooltip": "Date of the most recent reported plugback (AB only)",
      "folder": "Well Header",
    },
  },
  "groundwater_protection_formation": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Groundwater Protection Formation",
      "folder": "Well Header",
    },
  },
  "lahee_class": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Lahee Class",
      "folder": "Well Header",
    },
  },
  "head_lessor": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Head Lessor",
      "folder": "Well Header",
    },
  },
  "base_of_groundwater_elevation_kb": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "KB Base of Groundwater Elevation",
      "folder": "Well Header",
    },
  },
  "base_of_groundwater_elevation_asl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "ASL Base of Groundwater Elevation",
      "folder": "Well Header",
    },
  },
  "is_confidential": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Is Confidential",
      "folder": "Well Header",
    },
  },
  "confidential_release_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Confidential Release Date",
      "folder": "Well Header",
    },
  },
  "surface_latitude": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Surface Latitude",
      "folder": "Location",
    },
  },
  "surface_longitude": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Surface Longitude",
      "folder": "Location",
    },
  },
  "bottom_latitude": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Bottom Latitude",
      "folder": "Location",
    },
    "gpt": {
      "hint": "Default to using this column when asked for well location unless surface location is requested explicitly",
    },
  },
  "bottom_longitude": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Bottom Longitude",
      "folder": "Location",
    },
    "gpt": {
      "hint": "Default to using this column when asked for well location unless surface location is requested explicitly",
    },
  },
  "surface_location": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Surface DLS/NTS",
      "folder": "Location",
      "isShownByDefault": true,
      "tnum": true,
    },
    "gpt": {
      "hint": "Surface location (DLS or NTS) ONLY. Use this field only when the user explicitly says “surface” (e.g., “surface location”, “surface DLS/NTS”, “surface LSD”). Do NOT use for UWIs or well identifiers. Examples: 02-09-066-06W6 or D-089-E/093-P-12. Pad with leading zeros when necessary.",
    },
  },
  "grid_system": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["DLS", "NTS"],
    },
    "ui": {
      "label": "Grid System",
      "folder": "Location",
    },
  },
  "lsd": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "DLS LSD (Surface)",
      "folder": "Location",
    },
  },
  "sec": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "DLS Section (Surface)",
      "folder": "Location",
    },
  },
  "twn": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "DLS Township (Surface)",
      "folder": "Location",
    },
  },
  "range": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "DLS Range (Surface)",
      "folder": "Location",
    },
  },
  "meridian": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "DLS Meridian (Surface)",
      "folder": "Location",
    },
  },
  "nts_qtr_unit": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "NTS QTR Unit",
      "folder": "Location",
    },
  },
  "nts_unit": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "NTS Unit",
      "folder": "Location",
    },
  },
  "nts_block": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "NTS Block",
      "folder": "Location",
    },
  },
  "nts_map": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "NTS Map",
      "folder": "Location",
    },
  },
  "nts_map_sheet": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "NTS Map Sheet",
      "folder": "Location",
    },
  },
  "nts_grid": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "NTS Grid",
      "folder": "Location",
    },
  },
  "has_recent_production": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Recent Volumetric Activity",
      "tooltip": "Has production or injection volume in the latest volumetrics reporting month",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Has production or injection volume in the most recent reporting month available from AER (typically ~1 month behind current date)",
    },
  },
  "first_volumetric_activity_month": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "First Volumetric Activity Month",
      "tooltip": "Date of the first reported production or injection volume",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Date of the first reported production or injection volume",
    },
  },
  "first_production_month": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "First Production Month",
      "folder": "Production Summary",
    },
  },
  "first_injection_month": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "First Injection Month",
      "folder": "Production Summary",
    },
  },
  "last_activity_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Last Volumetric Activity Month",
      "tooltip": "Date of the most recent reported production or injection volume",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Date of the most recent reported production or injection volume",
    },
  },
  "last_production_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Last Production Month",
      "folder": "Production Summary",
    },
  },
  "last_ngl_production_activity_month": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Last NGL Production Month",
      "folder": "Production Summary",
    },
  },
  "last_injection_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Last Injection Month",
      "folder": "Production Summary",
    },
  },
  "last_production_hours": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Last Production Hours",
      "folder": "Production Summary",
    },
  },
  "last_injection_hours": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Last Injection Hours",
      "folder": "Production Summary",
    },
  },
  "api_gravity": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "API Gravity",
      "folder": "Production Summary",
    },
  },
  "cumulative_oil": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Cumulative Oil",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Total oil production to date",
    },
  },
  "cumulative_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3",
    },
    "ui": {
      "label": "Cumulative Gas",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Total gas production volume to date",
    },
  },
  "cumulative_best_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3",
    },
    "ui": {
      "label": "Cumulative Best Gas",
      "tooltip": "Total marketable gas production volume to date, or raw gas where marketable gas is not available",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Total best gas production volume to date (marketable gas if available, otherwise raw gas)",
    },
  },
  "cumulative_water": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Cumulative Water",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Total water production volume to date",
    },
  },
  "cumulative_water_injection": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Cumulative Water Injection",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Total water injection volume to date",
    },
  },
  "cumulative_steam_injection": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Cumulative Steam Injection",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Total steam injection volume to date",
    },
  },
  "cumulative_gas_injection": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3",
    },
    "ui": {
      "label": "Cumulative Gas Injection",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Total gas injection volume to date",
    },
  },
  "cumulative_ngl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Cumulative NGL",
      "tooltip": "Total NGL (C2, C3, C4) production volume to date",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Total NGL (C2, C3, C4) production volume to date",
    },
  },
  "cumulative_condensate": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Cumulative Condensate",
      "tooltip": "Total condensate (C5+) production volume to date",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Total condensate (C5+) production volume to date",
    },
  },
  "recent_oil": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Recent Oil",
      "folder": "Production Summary",
      "tooltip": "Volume of oil produced in the latest volumetrics reporting month",
      "width": 125,
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Oil production for the most recent reporting month available from AER (typically ~1 month behind current date)",
    },
  },
  "recent_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3",
    },
    "ui": {
      "label": "Recent Gas",
      "folder": "Production Summary",
      "tooltip": "Volume of gas produced in the latest volumetrics reporting month",
      "width": 125,
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Gas production for the most recent reporting month available from AER (typically ~1 month behind current date)",
    },
  },
  "recent_best_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3",
    },
    "ui": {
      "label": "Recent Best Gas",
      "folder": "Production Summary",
      "tooltip": "Marketable gas produced in the latest volumetrics reporting month, or raw gas where marketable gas is not available",
      "width": 125,
    },
    "gpt": {
      "hint": "Best gas production for the most recent reporting month available from AER (marketable gas if available, otherwise raw gas)",
    },
  },
  "recent_water": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Recent Water",
      "tooltip": "Volume of water produced in the latest volumetrics reporting month",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Water production for the most recent reporting month available from AER (typically ~1 month behind current date)",
    },
  },
  "recent_ngl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Recent NGL",
      "tooltip": "Volume of NGL (C2, C3, C4) produced in the latest volumetrics reporting month",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "NGL production (C2, C3, C4) for the most recent reporting month available from AER (typically ~1 month behind current date)",
    },
  },
  "recent_condensate": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Recent Condensate",
      "tooltip": "Volume of condensate (C5+) produced in the latest volumetrics reporting month",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Condensate production (C5+) for the most recent reporting month available from AER (typically ~1 month behind current date)",
    },
  },
  "recent_water_injection": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Recent Water Injection",
      "tooltip": "Volume of water injected in the latest volumetrics reporting month",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Water injection for the most recent reporting month available from AER (typically ~1 month behind current date)",
    },
  },
  "recent_steam_injection": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Recent Steam Injection",
      "tooltip": "Volume of steam injected in the latest volumetrics reporting month",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Steam injection for the most recent reporting month available from AER (typically ~1 month behind current date)",
    },
  },
  "recent_gas_injection": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3",
    },
    "ui": {
      "label": "Recent Gas Injection",
      "tooltip": "Volume of gas injected in the latest volumetrics reporting month",
      "folder": "Production Summary",
    },
    "gpt": {
      "hint": "Gas injection for the most recent reporting month available from AER (typically ~1 month behind current date)",
    },
  },
  "last_oil_rate": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Oil Rate",
      "tooltip": "Volume of oil produced in the latest volumetrics reporting month, divided by days in that month",
      "folder": "Production Summary",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "last_gas_rate": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3/d",
    },
    "ui": {
      "label": "Last Gas Rate",
      "tooltip": "Volume of gas produced in the latest volumetrics reporting month, divided by days in that month",
      "folder": "Production Summary",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "last_water_rate": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Water Rate",
      "tooltip": "Volume of water produced in the latest volumetrics reporting month, divided by days in that month",
      "folder": "Production Summary",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "last_ngl_rate": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last NGL Rate",
      "tooltip": "Volume of NGL (C2, C3, C4) produced in the latest volumetrics reporting month, divided by days in that month",
      "folder": "Production Summary",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "last_condensate_rate": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Condensate Rate",
      "tooltip": "Volume of condensate (C5+) produced in the latest volumetrics reporting month, divided by days in that month",
      "folder": "Production Summary",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "last_water_injection_rate": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3/d",
    },
    "ui": {
      "label": "Last Water Injection Rate",
      "tooltip": "Volume of water injected in the latest volumetrics reporting month, divided by days in that month",
      "folder": "Production Summary",
    },
    "gpt": {
      "exclude": true,
    },
  },
  "ip3_oil": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "IP3 Oil",
      "folder": "Production Summary",
    },
  },
  "ip3_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3",
    },
    "ui": {
      "label": "IP3 Gas",
      "folder": "Production Summary",
    },
  },
  "ip3_water": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "IP3 Water",
      "folder": "Production Summary",
    },
  },
  "ip3_condensate": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "IP3 Condensate",
      "folder": "Production Summary",
    },
  },
  "ip3_ngl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "IP3 NGL",
      "folder": "Production Summary",
    },
  },
  "ip12_oil": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "IP12 Oil",
      "folder": "Production Summary",
    },
  },
  "ip12_gas": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "e3m3",
    },
    "ui": {
      "label": "IP12 Gas",
      "folder": "Production Summary",
    },
  },
  "ip12_water": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "IP12 Water",
      "folder": "Production Summary",
    },
  },
  "ip12_condensate": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "IP12 Condensate",
      "folder": "Production Summary",
    },
  },
  "ip12_ngl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "IP12 NGL",
      "folder": "Production Summary",
    },
  },
  "sample_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Sample Date",
      "folder": "Gas Analysis",
    },
  },
  "fs_h2": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "H2",
      "folder": "Gas Analysis",
    },
  },
  "fs_h2s": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "H2S",
      "folder": "Gas Analysis",
    },
  },
  "fs_co2": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "CO2",
      "folder": "Gas Analysis",
    },
  },
  "fs_n2": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "N2",
      "folder": "Gas Analysis",
    },
  },
  "fs_he": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "HE",
      "folder": "Gas Analysis",
    },
  },
  "fs_c1": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "C1",
      "folder": "Gas Analysis",
    },
  },
  "fs_c2": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "C2",
      "folder": "Gas Analysis",
    },
  },
  "fs_c3": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "C3",
      "folder": "Gas Analysis",
    },
  },
  "fs_ic4": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "iC4",
      "folder": "Gas Analysis",
    },
  },
  "fs_nc4": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "nC4",
      "folder": "Gas Analysis",
    },
  },
  "fs_ic5": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "iC5",
      "folder": "Gas Analysis",
    },
  },
  "fs_nc5": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "nC5",
      "folder": "Gas Analysis",
    },
  },
  "fs_c6": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "C6",
      "folder": "Gas Analysis",
    },
  },
  "fs_c7_plus": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "C7+",
      "folder": "Gas Analysis",
    },
  },
  "relative_density": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Relative Density",
      "folder": "Gas Analysis",
    },
  },
  "molecular_weight": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Molecular Weight",
      "folder": "Gas Analysis",
    },
  },
  "gas_gross_heat_value_moisture_and_acid_gas_free": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Gross Heat Value (Moisture and Acid Gas Free)",
      "folder": "Gas Analysis",
    },
  },
  "calculated_pcp_sampled": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "kPa",
    },
    "ui": {
      "label": "Calculated PCP Sampled",
      "folder": "Gas Analysis",
    },
  },
  "calculated_tcp_sampled": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "K",
    },
    "ui": {
      "label": "Calculated TCP Sampled",
      "folder": "Gas Analysis",
    },
  },
  "molecular_weight_of_c7_plus": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Molecular Weight of C7+",
      "folder": "Gas Analysis",
    },
  },
  "number_of_stages": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Number of Stages",
      "folder": "Completions Summary",
    },
  },
  "total_water_volume_m3": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m3",
    },
    "ui": {
      "label": "Total Water Volume",
      "folder": "Completions Summary",
    },
  },
  "total_proppant": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "tonne",
    },
    "ui": {
      "label": "Total Proppant",
      "folder": "Completions Summary",
    },
  },
  "proppant_per_stage": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "tonne",
    },
    "ui": {
      "label": "Proppant Per Stage",
      "folder": "Completions Summary",
    },
  },
  "lateral_length": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "Lateral Length",
      "folder": "Completions Summary",
    },
  },
  "average_interval_length": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Average Interval Length",
      "folder": "Completions Summary",
    },
  },
  "frac_spacing": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Frac Spacing",
      "folder": "Completions Summary",
    },
  },
  "is_monobore": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Is Monobore",
      "folder": "Drilling & Well Design",
    },
  },
  "is_open_hole": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Is Open Hole",
      "folder": "Drilling & Well Design",
    },
  },
  "has_kick": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Kick",
      "folder": "Drilling & Well Design",
    },
  },
  "has_lost_circulation": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Lost Circulation",
      "folder": "Drilling & Well Design",
    },
  },
  "has_blowout": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Blowout",
      "folder": "Drilling & Well Design",
    },
  },
  "has_casing_patch": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Casing Patch",
      "folder": "Drilling & Well Design",
    },
  },
  "has_liner": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Liner",
      "folder": "Drilling & Well Design",
    },
  },
  "has_cemented_liner": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Cemented Liner",
      "folder": "Drilling & Well Design",
    },
  },
  "has_dst": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has DST",
      "folder": "Drilling & Well Design",
    },
  },
  "drilling_contractor": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Drilling Contractor",
      "folder": "Drilling & Well Design",
    },
  },
  "drilling_contractor_rigno": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Rig Number",
      "folder": "Drilling & Well Design",
    },
  },
  "has_complaint": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Complaint",
      "folder": "Compliance",
    },
  },
  "has_spill": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Spill",
      "folder": "Compliance",
    },
  },
  "has_surface_abandonment": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Surface Abandonment",
      "folder": "Compliance",
    },
  },
  "has_casing_failure_history": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Casing Failure History",
      "folder": "Compliance",
    },
  },
  "has_vent_flow_history": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Vent Flow History",
      "folder": "Compliance",
    },
  },
  "has_open_vent_flow_case": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Open Vent Flow Case",
      "folder": "Compliance",
    },
  },
  "has_open_casing_failure": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Open Casing Failure",
      "folder": "Compliance",
    },
  },
  "has_base_of_groundwater_monitoring_flag": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Base of Groundwater Monitoring",
      "folder": "Compliance",
    },
  },
  "has_gas_migration_flag": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Gas Migration",
      "folder": "Compliance",
    },
  },
  "has_swab_well_flag": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Is Swab Well",
      "folder": "Compliance",
    },
  },
  "has_orphan_flag": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Is Orphan Well",
      "folder": "Compliance",
    },
  },
  "aer_d13_compliance": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "AER-D13 Compliance",
      "folder": "Compliance",
    },
  },
  "industry_reported_suspension_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Industry Reported Suspension Date",
      "folder": "Compliance",
    },
  },
  "industry_reported_inspection_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Industry Reported Inspection Date",
      "folder": "Compliance",
    },
  },
  "next_inspection_due_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Next Inspection Due Date",
      "folder": "Compliance",
    },
  },
  "last_reported_downhole_operation": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Last Reported Downhole Operation",
      "folder": "Compliance",
    },
  },
  "industry_reported_risk_class": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Industry Reported Risk Class",
      "folder": "Compliance",
    },
  },
  "aer_deemed_risk_class": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "AER-D13 Deemed Risk Class",
      "folder": "Compliance",
    },
  },
  "medium_risk_type_6_well": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Medium Risk Type 6 Well",
      "folder": "Compliance",
    },
  },
  "aer_approved_closure_plan_project_start_year": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "AER-D13 Approved Closure Plan Project Start Year",
      "folder": "Compliance",
    },
  },
  "noncompliance_details": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Non-Compliance Details",
      "folder": "Compliance",
      "isNotSortable": true,
    },
  },
  "iwcp": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "IWCP",
      "folder": "Compliance",
    },
  },
  "aer_d13_exclusion_reason": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "AER-D13 Exclusion Reason",
      "folder": "Compliance",
      "isNotSortable": true,
    },
  },
  "additional_information": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Additional Information",
      "folder": "Compliance",
      "isNotSortable": true,
    },
  },
  "has_digital_logs": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Digital Logs",
      "folder": "Data Availability",
    },
  },
  "has_raster_logs": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Raster Logs",
      "folder": "Data Availability",
    },
  },
  "has_gas_analysis": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Gas Analysis",
      "folder": "Data Availability",
    },
  },
  "has_documents": {
    // Do not rename this field, it's used in Maps UI!
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Documents",
      "folder": "Data Availability",
    },
  },
  "has_oil_analysis": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Oil Analysis",
      "folder": "Data Availability",
    },
  },
  "has_water_analysis": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Water Analysis",
      "folder": "Data Availability",
    },
  },
  "has_pressure_data": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Pressure Data",
      "folder": "Data Availability",
    },
  },
  "has_tour_report": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Tour Report",
      "folder": "Data Availability",
    },
  },
  "has_completions_report": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Completions Report",
      "folder": "Data Availability",
    },
  },
  "has_digital_directional_survey": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Digital Directional Survey",
      "folder": "Data Availability",
    },
  },
  "has_pdf_directional_survey": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has PDF Directional Survey",
      "folder": "Data Availability",
    },
  },
  "has_core_data": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Core Data",
      "folder": "Data Availability",
    },
  },
  "well_path_source": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "AER ST37 Shapefile",
        "Directional Survey",
        "Stick",
        "3-Point Stick",
      ],
    },
    "ui": {
      "label": "Well Path Source",
      "folder": "Data Availability",
    },
  },
  "facility_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Facility IDs",
      "folder": "Connected Objects",
      "isNotSortable": true,
    },
  },
  "connected_facility_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Connected Facility Names",
      "folder": "Connected Objects",
      "isNotSortable": true,
    },
  },
  "connected_facility_sub_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Connected Facility Subtypes",
      "folder": "Connected Objects",
      "isNotSortable": true,
    },
  },
  "connected_facility_subcode": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Connected Facility Subcodes",
      "folder": "Connected Objects",
      "isNotSortable": true,
    },
  },
  "connected_facility_status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Connected Facility Statuses",
      "folder": "Connected Objects",
      "isNotSortable": true,
    },
  },
  "connected_facility_licensee": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Connected Facility Licensees",
      "folder": "Connected Objects",
      "isNotSortable": true,
    },
  },
  "connected_facility_operator": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Connected Facility Operators",
      "folder": "Connected Objects",
      "isNotSortable": true,
    },
  },
  "well_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "country": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
    "gpt": {
      "exclude": true,
    },
  },
  "symbol": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "related_ids": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "well_licence_nid": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "well_event_nid": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "well_path_geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
  "frac_supplier": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Supplier",
      "folder": "Completions Summary",
    },
  },
}
